


import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {
  ICalculatedMetrics,
  IMetricCalculator, IMetricCalculatorCalculationChangedEvent,
  IPeriod,
  IPeriodMetricContext
} from "../PA.UIM.Metric/PA.UIM.Metric.IF";
import {IMetricParameterSet, IMetrics} from "../PA.Metric.Services/PA.Metrics.IF";
import {ASync} from "../PA.Core/Basic/ASync";
import * as _ from "lodash";
import {FinancialUtils} from "../PA.Core/Basic/FinancialUtils";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {CannibalizationSetBO} from "../PA.Consumption.BusinessObjects/CannibalizationSetBO";
import {Subscription} from "rxjs";

interface ICannMetricSummary {
  CNSMP_CANN_VCTM_UNITS:      number,
  CNSMP_CANN_VCTM_RTLSLS:     number,
  CNSMP_CANN_VCTM_STAT:       number,
  CNSMP_CANN_VCTM_WT:         number,
  CNSMP_CANN_VCTM_LISTSLS:    number,
  CNSMP_CANN_VCTM_NETLISTSLS: number,
  CNSMP_CANN_VCTM_PRFTCNTRB:  number,

  CNSMP_CANN_AGGR_UNITS:      number,
  CNSMP_CANN_AGGR_RTLSLS:     number,
  CNSMP_CANN_AGGR_STAT:       number,
  CNSMP_CANN_AGGR_WT:         number,
  CNSMP_CANN_AGGR_LISTSLS:    number,
  CNSMP_CANN_AGGR_NETLISTSLS: number,
  CNSMP_CANN_AGGR_PRFTCNTRB:  number
}


export class CannibalizationSetGraphCalculator
  implements IMetricCalculator
{
  private _CalculationChanged: BehaviorSubject<IMetricCalculatorCalculationChangedEvent>;
  private _CannibalizationSetBO: CannibalizationSetBO
  private _CalcFinishedSub: Subscription

  constructor(){

    this._CannibalizationSetBO = undefined
    this._CalcFinishedSub = undefined
    this._CalculationChanged = new BehaviorSubject<IMetricCalculatorCalculationChangedEvent>(undefined)

  }

  Register(aCannibalizationSetBO: CannibalizationSetBO){
    const self = this
    this.UnRegister()

    this._CannibalizationSetBO = aCannibalizationSetBO

    if(this._CannibalizationSetBO){
      this._CalcFinishedSub = this._CannibalizationSetBO.ActualsCalculator.OnCalculateComplete.subscribe(self._OnCalculateComplete.bind(self))
    }

  }

  UnRegister(){

    if(this._CalcFinishedSub){
      this._CalcFinishedSub.unsubscribe()
      this._CalcFinishedSub = undefined
    }

    this._CannibalizationSetBO = undefined
  }

  private _OnCalculateComplete(){
    this.notifyMetricCalculationChanged()
  }

//<editor-fold desc = "IMetricsCalculator operations">

  get CalculationChanged(): BehaviorSubject<IMetricCalculatorCalculationChangedEvent> {
    return this._CalculationChanged
  }

  private notifyMetricCalculationChanged(){
    this.CalculationChanged.next({MetricCalculator: this})
  }

  BeforeCalcualteMetrics(pmc: IPeriodMetricContext, mps: IMetricParameterSet): Promise<void> {
    return ASync.resolve();
  }

  CalculateMetrics(pmc: IPeriodMetricContext, Period: IPeriod, inMetrics: IMetrics): Promise<ICalculatedMetrics> {
    const self = this

    return new Promise<ICalculatedMetrics>((resolve, error) => {
      let returnMetrics = {

        CNSMP_BASE_UNITS:      inMetrics.CNSMP_SYND_BASE_UNITS,
        CNSMP_BASE_RTLSLS:     inMetrics.CNSMP_SYND_BASE_RTLSLS ,
        CNSMP_BASE_STAT:       inMetrics.CNSMP_SYND_BASE_STAT ,
        CNSMP_BASE_WT:         inMetrics.CNSMP_SYND_BASE_WT ,
        CNSMP_BASE_LISTSLS:    inMetrics.CNSMP_SYND_BASE_LISTSLS ,
        CNSMP_BASE_NETLISTSLS: inMetrics.CNSMP_SYND_BASE_NETLISTSLS ,
        CNSMP_BASE_PRFTCNTRB:  inMetrics.CNSMP_SYND_BASE_PRFTCNTRB,

        CNSMP_INCR_UNITS:        inMetrics.CNSMP_INCR_UNITS,
        CNSMP_INCR_RTLSLS:       inMetrics.CNSMP_INCR_RTLSLS,
        CNSMP_INCR_STAT:         inMetrics.CNSMP_INCR_STAT,
        CNSMP_INCR_WT:           inMetrics.CNSMP_INCR_WT,
        CNSMP_INCR_LISTSLS:      inMetrics.CNSMP_INCR_LISTSLS,
        CNSMP_INCR_NETLISTSLS:   inMetrics.CNSMP_INCR_NETLISTSLS,
        CNSMP_INCR_PRFTCNTRB:    inMetrics.CNSMP_INCR_PRFTCNTRB,

        CNSMP_CANN_VCTM_UNITS:      0,
        CNSMP_CANN_VCTM_RTLSLS:     0,
        CNSMP_CANN_VCTM_STAT:       0,
        CNSMP_CANN_VCTM_WT:         0,
        CNSMP_CANN_VCTM_LISTSLS:    0,
        CNSMP_CANN_VCTM_NETLISTSLS: 0,
        CNSMP_CANN_VCTM_PRFTCNTRB:  0,

        CNSMP_CANN_AGGR_UNITS:      0,
        CNSMP_CANN_AGGR_RTLSLS:     0,
        CNSMP_CANN_AGGR_STAT:       0,
        CNSMP_CANN_AGGR_WT:         0,
        CNSMP_CANN_AGGR_LISTSLS:    0,
        CNSMP_CANN_AGGR_NETLISTSLS: 0,
        CNSMP_CANN_AGGR_PRFTCNTRB:  0

      }

      let cMtrcs = self.getCannibalizationMetrics(pmc, Period)

      returnMetrics.CNSMP_CANN_VCTM_UNITS      += cMtrcs.CNSMP_CANN_VCTM_UNITS
      returnMetrics.CNSMP_CANN_VCTM_RTLSLS     += cMtrcs.CNSMP_CANN_VCTM_RTLSLS
      returnMetrics.CNSMP_CANN_VCTM_STAT       += cMtrcs.CNSMP_CANN_VCTM_STAT
      returnMetrics.CNSMP_CANN_VCTM_WT         += cMtrcs.CNSMP_CANN_VCTM_WT
      returnMetrics.CNSMP_CANN_VCTM_LISTSLS    += cMtrcs.CNSMP_CANN_VCTM_LISTSLS
      returnMetrics.CNSMP_CANN_VCTM_NETLISTSLS += cMtrcs.CNSMP_CANN_VCTM_NETLISTSLS
      returnMetrics.CNSMP_CANN_VCTM_PRFTCNTRB  += cMtrcs.CNSMP_CANN_VCTM_PRFTCNTRB

      returnMetrics.CNSMP_CANN_AGGR_UNITS      += cMtrcs.CNSMP_CANN_AGGR_UNITS
      returnMetrics.CNSMP_CANN_AGGR_RTLSLS     += cMtrcs.CNSMP_CANN_AGGR_RTLSLS
      returnMetrics.CNSMP_CANN_AGGR_STAT       += cMtrcs.CNSMP_CANN_AGGR_STAT
      returnMetrics.CNSMP_CANN_AGGR_WT         += cMtrcs.CNSMP_CANN_AGGR_WT
      returnMetrics.CNSMP_CANN_AGGR_LISTSLS    += cMtrcs.CNSMP_CANN_AGGR_LISTSLS
      returnMetrics.CNSMP_CANN_AGGR_NETLISTSLS += cMtrcs.CNSMP_CANN_AGGR_NETLISTSLS
      returnMetrics.CNSMP_CANN_AGGR_PRFTCNTRB  += cMtrcs.CNSMP_CANN_AGGR_PRFTCNTRB

      resolve(returnMetrics)

    })

  }

  private getCannibalizationMetrics(pmc: IPeriodMetricContext, Period: IPeriod): ICannMetricSummary {
    let canMtrcs: ICannMetricSummary = {
      CNSMP_CANN_VCTM_UNITS:      0,
      CNSMP_CANN_VCTM_RTLSLS:     0,
      CNSMP_CANN_VCTM_STAT:       0,
      CNSMP_CANN_VCTM_WT:         0,
      CNSMP_CANN_VCTM_LISTSLS:    0,
      CNSMP_CANN_VCTM_NETLISTSLS: 0,
      CNSMP_CANN_VCTM_PRFTCNTRB:  0,

      CNSMP_CANN_AGGR_UNITS:      0,
      CNSMP_CANN_AGGR_RTLSLS:     0,
      CNSMP_CANN_AGGR_STAT:       0,
      CNSMP_CANN_AGGR_WT:         0,
      CNSMP_CANN_AGGR_LISTSLS:    0,
      CNSMP_CANN_AGGR_NETLISTSLS: 0,
      CNSMP_CANN_AGGR_PRFTCNTRB:  0

    }

    let eb = pmc.ExecutionBounds
    let cs = this._CannibalizationSetBO

    if(_.isEmpty(eb)){ return canMtrcs }
    if(_.isEmpty(cs)){ return canMtrcs }

    let arrFinishedProducts = _.map(pmc.FinishedProducts_Selected, (aFP)=> { return aFP.cif.WB_PROD_ID })
    let arrProductGroups = _.map(eb.Execution_ProductGroups, (aPG) => { return aPG.cif.WB_PRDGRP_ID })
    let bUseProductMetrics = ! _.isEmpty(arrFinishedProducts)

    let arrPlanningCustomers: number[] = _.map(eb.Execution_PlanningCustomers, (aPC) => { return aPC.cif.WB_CUST_ID})

    let dctCustomerSel = _.keyBy(arrPlanningCustomers, (a) => { return a})
    let dctProductGroups = _.keyBy(arrProductGroups, (a) => { return a})
    let dctFinishedProduct = _.keyBy(arrFinishedProducts, (a) => { return a})


    _.forEach(cs.WB_CannibalizationSet.WB_CannibalizationSetProductGroupRows, (aCSPG) => {

      if(!aCSPG.isActive){ return }


      let bIncludeVictimMetrics = false
      let bIncludeAggressorMetrics = false

      if((aCSPG.cif.WB_CUST_ID_PLANNING_VICT in dctCustomerSel) &&
         (aCSPG.cif.WB_PRDGRP_ID_VICT in dctProductGroups) &&
          DateUtils.InRange(aCSPG.EffectiveVictimDt, Period.Range)){
        bIncludeVictimMetrics = true
      }

      if((aCSPG.cif.WB_CUST_ID_PLANNING_AGGR in dctCustomerSel) &&
        (aCSPG.cif.WB_PRDGRP_ID_AGGR in dctProductGroups) &&
        DateUtils.InRange(aCSPG.EffectiveAggressorDt, Period.Range)){
        bIncludeAggressorMetrics = true
      }

      if(!(bIncludeAggressorMetrics || bIncludeVictimMetrics)){
        return
      }



      if(bUseProductMetrics){
        _.forEach(aCSPG.WB_CannibalizationSetProductRows, (aCSPrd) => {
          if(!aCSPrd.isActive){ return }

          if(bIncludeVictimMetrics && (aCSPrd.cif.PRDGRP_ROLE == "Victim") && (aCSPrd.cif.WB_PROD_ID in dctFinishedProduct)){
            canMtrcs.CNSMP_CANN_VCTM_UNITS += aCSPrd.cif.VICTIM_UNITS
            canMtrcs.CNSMP_CANN_VCTM_RTLSLS += aCSPrd.cif.VICTIM_RTLSLS
            canMtrcs.CNSMP_CANN_VCTM_LISTSLS += aCSPrd.cif.VICTIM_LSTSLS
            canMtrcs.CNSMP_CANN_VCTM_NETLISTSLS += aCSPrd.cif.VICTIM_LSTSLS
            canMtrcs.CNSMP_CANN_VCTM_PRFTCNTRB += aCSPrd.cif.VICTIM_PROFIT
          }

          if(bIncludeAggressorMetrics && (aCSPrd.cif.PRDGRP_ROLE == "Aggressor") && (aCSPrd.cif.WB_PROD_ID in dctFinishedProduct)){
            canMtrcs.CNSMP_CANN_AGGR_UNITS += aCSPrd.cif.AGGR_UNITS
            canMtrcs.CNSMP_CANN_AGGR_RTLSLS += aCSPrd.cif.AGGR_RTLSLS
            canMtrcs.CNSMP_CANN_AGGR_LISTSLS += aCSPrd.cif.AGGR_LSTSLS
            canMtrcs.CNSMP_CANN_AGGR_NETLISTSLS += aCSPrd.cif.AGGR_LSTSLS
            canMtrcs.CNSMP_CANN_AGGR_PRFTCNTRB += aCSPrd.cif.AGGR_PROFIT
          }

        })

      } else {

        if(bIncludeVictimMetrics){
          canMtrcs.CNSMP_CANN_VCTM_UNITS += aCSPG.cif.VICTIM_UNITS
          canMtrcs.CNSMP_CANN_VCTM_RTLSLS += aCSPG.cif.VICTIM_RTLSLS
          canMtrcs.CNSMP_CANN_VCTM_LISTSLS += aCSPG.cif.VICTIM_LSTSLS
          canMtrcs.CNSMP_CANN_VCTM_NETLISTSLS += aCSPG.cif.VICTIM_LSTSLS
          canMtrcs.CNSMP_CANN_VCTM_PRFTCNTRB += aCSPG.cif.VICTIM_PROFIT
        }
        if(bIncludeAggressorMetrics){
          canMtrcs.CNSMP_CANN_AGGR_UNITS += aCSPG.cif.AGGR_UNITS
          canMtrcs.CNSMP_CANN_AGGR_RTLSLS += aCSPG.cif.AGGR_RTLSLS
          canMtrcs.CNSMP_CANN_AGGR_LISTSLS += aCSPG.cif.AGGR_LSTSLS
          canMtrcs.CNSMP_CANN_AGGR_NETLISTSLS += aCSPG.cif.AGGR_LSTSLS
          canMtrcs.CNSMP_CANN_AGGR_PRFTCNTRB += aCSPG.cif.AGGR_PROFIT
        }

      }


    })

    return canMtrcs
  }


}





//</editor-fold>